import { matchPath, useLocation } from 'react-router-dom'
import { useIsSimplifiedReceptionLocked } from '@/hooks/useIsSimplifiedReceptionLocked'
import { SimplifiedReceptionPage } from './SimplifiedReceptionPage'

/** Pages a locked staff member may still open: the live consultation of a patient they just queued. */
const PATHS_ALLOWED_WHEN_LOCKED = ['/consultations/:consultationId/live']

/**
 * Replaces every authenticated page with the simplified reception interface when the
 * `simplified-reception-mode` flag is on and an admin turned the mode on for this staff member,
 * except the live consultation (vital signs, devices) reached from the reception screen.
 * Flag off → the usual application, unchanged.
 */
export function SimplifiedReceptionGate({ children }: { children: React.ReactElement }) {
  const isLocked = useIsSimplifiedReceptionLocked()
  const { pathname } = useLocation()
  const isAllowed = PATHS_ALLOWED_WHEN_LOCKED.some((path) => matchPath(path, pathname))

  return isLocked && !isAllowed ? <SimplifiedReceptionPage /> : children
}
